import { fetch } from '@/plugin/axios/index.js'


/**
 * 保存
 * @param {Object} data 
 */
export function saveAssign(data) {
  return fetch({
    url: '/auth/assign/save',
    method: 'POST',
    data
  })
}


/**
 * 保存
 * @param {Object} data 
 */
export function saveBatch(data) {
  return fetch({
    url: '/auth/assign/saveBatch',
    method: 'POST',
    data
  })
}


/**
 * 列表
 * @param {Object} data 
 */
export function getAssignPageList(data) {
  return fetch({
    url: '/auth/assign/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 详情
 */
export function getAssignDetail(params) {
  return fetch({
    url: '/auth/assign/detail',
    method: 'GET',
    params
  })
}


/**
 * 删除
 * @param {Object} data 
 */
export function deleteAssign(data) {
  return fetch({
    url: '/auth/assign/delete',
    method: 'POST',
    data
  })
}


/**
 * 修改状态
 * @param {Object} data 
 */
export function changeAssignStatus(data) {
  return fetch({
    url: '/auth/assign/userChangeStatus',
    method: 'POST',
    data
  })
}


/**
 * 根据部门获取员工
 * @param {Object} data 
 */
export function getSimpleList(data) {
  return fetch({
    url: '/auth/subPlatform/user/simpleList',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/TaskAssigned/index.js